<template>
  <div
    class="hover-dropdown-fade w-auto px-0 d-flex align-items-center mr-8 mr-sm-16 position-relative"
  >
     <b-button v-if="isNotManager" variant="text" class="btn-icon-only" @click="togglePopup">
      <i class="iconly-Curved-Notification hp-text-color-black-60 position-relative">
        <!-- Dynamic Notification Badge -->
        <span
          v-if="unreadMessages > 0"
          class="position-absolute translate-middle rounded-circle bg-primary hp-notification-circle"
          style="width: 6px; height: 6px; top: 2px"
        ></span>

        <!-- Display unreadMessages count next to the notification icon -->
        <span
          v-if="unreadMessages > 0"
          class="position-absolute badge bg-primary text-white"
          style="top: -10px; right: -10px; font-size: 12px; padding: 2px 6px"
        >
          {{ unreadMessages }}
        </span>
      </i>
    </b-button>

    <!-- Notification Pop-up -->
    <div
      v-if="showPopup"
      class="hp-notification-menu dropdown-fade position-absolute pt-18"
      style="width: 288px; top: 100%"
    >
      <div
        class="pt-32 pb-18 px-18 rounded border hp-border-color-black-40 hp-bg-black-0 hp-bg-dark-100 hp-border-color-dark-80"
      >
        <b-row align-v="center" align-h="between" class="mb-18">
          <b-col
            class="hp-flex-none w-auto h5 hp-text-color-black-100 hp-text-color-dark-10 hp-text-color-dark-0 mr-64 mb-0"
          >
            Notifications
          </b-col>

          <!-- Dynamic Message Count -->
          <b-col
            class="hp-flex-none w-auto hp-bg-color-primary-1 rounded-pill hp-badge-text hp-text-color-black-0 py-4 px-6 mr-12"
          >
            {{ unreadMessages }} New 
          </b-col>
        </b-row>

        <div class="divider my-4"></div>

        <!-- Notification List -->
        <ul class="list-group notification-list">
          <li
            v-for="notification in notifications"
            :key="notification.id || `${notification.vehicle_id || 'n-a'}-${notification.timestamp || ''}`"
            class="list-group-item"
          >
            <a @click="viewNotificationDetail(notification)"  class="notification-link"  style="cursor: pointer;">
              {{ notification.title }}
              {{ notification.message }}
              <span v-if="notification.viewed === 'false'" class="badge bg-warning">New</span>
                 <!-- Display the notification time -->
                 <div class="text-muted small mt-1">
                {{ formatTime(notification.timestamp) }}
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../axios";
import { BRow, BCol, BButton } from "bootstrap-vue";
import { mapGetters } from "vuex";
import {
  initNotificationRealtime,
  applyNotificationSync,
  notificationBus,
} from "../../../utils/notificationRealtime";
export default {
  props: ['notification'],
  components: {
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      unreadMessages: 0, 
      showPopup: false, 
      notifications: [], 
      type: "", 
      policeSound: null,
      adminSound: null,
    };
  },
  created() {
    this.fetchUserType();
    if (this.isNotManager) {
      initNotificationRealtime(this.type);
      notificationBus.$on("sync", this.onNotificationSync);
    }
    this.updateRequestCount();
  },
  beforeDestroy() {
    notificationBus.$off("sync", this.onNotificationSync);
  },
  computed: {
    ...mapGetters(['requestCount']), // Map the requestCount getter to this component
    isNotManager() {
     const userType = localStorage.getItem('type');
    return userType !== 'manager' && userType !== 'agent';
  }
  },
  methods: {
    updateRequestCount() {
      this.$store.dispatch('fetchRequestCount'); // Dispatch action to fetch request count
    },
    fetchUserType() {
      this.type = localStorage.getItem('type') || 'super_admin'; 
    },

    onNotificationSync({ payload, userType }) {
      if (userType !== this.type) {
        return;
      }

      const previousCount = this.unreadMessages;
      const synced = applyNotificationSync(
        this.notifications,
        this.unreadMessages,
        payload,
        userType
      );

      this.notifications = synced.notifications;
      this.unreadMessages = synced.unreadCount;

      if (this.unreadMessages === 0) {
        this.notifications = [];
      }

      if (payload.action === "created" && this.unreadMessages > previousCount) {
        this.showPopup = true;

        if (userType === "police") {
          this.playPoliceSound();
        } else if (userType === "super_admin") {
          this.playAdminSound();
        }

        this.$bvToast.toast(payload.message || "New notification received", {
          title: userType === "super_admin" ? "Notification" : "Success",
          variant: "success",
          solid: true,
          appendToast: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 3000,
        });
      }
    },

    playPoliceSound() {
      this.stopSounds(); 
      this.policeSound = new Audio('/notification.mp3'); 
      this.policeSound.play().catch((error) => {
      });
    },

    playAdminSound() {
      this.stopSounds(); 
      this.adminSound = new Audio('/admin_notification.mp3'); 
      this.adminSound.play().catch((error) => {
      });
    },

    stopSounds() {
      if (this.policeSound) {
        this.policeSound.pause();
        this.policeSound.currentTime = 0;
      }
      if (this.adminSound) {
        this.adminSound.pause();
        this.adminSound.currentTime = 0;
      }
    },

    async fetchUnreadMessages() {
      try {
        const cacheBuster = Date.now();
        const countResponse = this.type === "super_admin"
          ? await axios.get(`NotificationCountAdmin?_=${cacheBuster}`)
          : await axios.get(`NotificationCountPolice?_=${cacheBuster}`);

        const notificationsResponse = this.type === "super_admin"
          ? await axios.get(`getUserUnreadNotifications?_=${cacheBuster}`)
          : await axios.get(`getUnreadNotificationsPolice?_=${cacheBuster}`);

        this.unreadMessages = countResponse.data.data;

        this.notifications = notificationsResponse.data.notifications
          .filter((item) => item.viewed === "false")
          .map((item) => ({
          ...item,
          timestamp: item.created_at || new Date().toISOString(),
          message: item.notification?.message || item.message || "No message",
          title: item.notification?.title || item.title || "",
        }));

        if (this.unreadMessages === 0) {
          this.notifications = [];
        }
      } catch (error) {
        console.error(error);
      }
    },
    
    formatTime(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
    togglePopup() {
      this.showPopup = !this.showPopup;
      if (this.showPopup) {
        this.fetchUnreadMessages();
        this.stopSounds();
      }
    },

    async markNotificationAsViewed(id) {
      try {
        let response;

        if (this.type === 'super_admin') {
          response = await axios.get(`markAsViewedNotification/${id}?_=${Date.now()}`);
        } else if (this.type === 'police') {
          response = await axios.get(`markAsViewedNotificationPolice/${id}?_=${Date.now()}`);
        }

        if (response && response.data.success) {
          this.notifications = this.notifications.filter((n) => n.id !== id);
          this.unreadMessages = Math.max(0, this.unreadMessages - 1);

          notificationBus.$emit("sync", {
            payload: {
              action: "viewed",
              id,
              notification_id: id,
              recipient_record_id: id,
              unread_count: this.unreadMessages,
            },
            userType: this.type,
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    async viewNotificationDetail(notification) {
      // Stop notification sound when viewing details
      this.stopSounds();

      let id = notification?.id;

      // Realtime Pusher payload for super_admin may not include notification id.
      // Refresh unread notifications and resolve the latest matching DB notification.
      if (!id && this.type === "super_admin") {
        await this.fetchUnreadMessages();
        const matchedNotification = this.notifications.find((item) => {
          return (
            item?.vehicle_id === notification?.vehicle_id &&
            item?.message === (notification?.message || "No message")
          );
        });
        id = matchedNotification?.id;
      }

      if (!id) {
        this.$bvToast.toast("Unable to open notification details. Please refresh and try again.", {
          title: "Notification",
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 3000,
        });
        return;
      }

      // Mark notification as viewed based on user type
      await this.markNotificationAsViewed(id);
      
      // Navigate to the detail page
      if (this.type === 'super_admin') {
        this.$router.push({
          name: "DetailNotificationPage", // Super admin's detail notification page
          params: { id }, 
        });
      } else if (this.type === 'police') {
        this.$router.push({
          name: "PoliceNotificationDetailPage", 
          params: { id },
        });
      }
    },
  },

  mounted() {
    this.fetchUnreadMessages();
    
  },
};
</script>

<style scoped>
.notification-detail-page {
  padding: 20px;
}

.card-title {
  font-weight: bold;
}

.card-text {
  margin-bottom: 10px;
}

.notification-list {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 10px; 
}
.notification-link {
  font-weight: bold;
}
</style>